import styled from 'styled-components';

interface MarkerProps {
  isMoving?: boolean;
}

export const Marker = styled.div<MarkerProps>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.2);
  }

  position: absolute;
  top: calc(50% - 15px);
  left: calc(50% - 15px);

  display: flex;
  justify-content: center;
  align-items: center;

  transition: all 0.3s ease-in-out;
  ${(props) => props.isMoving && `transform: translateY(-100%);`};
`;

export const ShadowEllipsis = styled.div`
  border-radius: 80%;
  width: 20px;
  height: 20px;
  background: black;
  opacity: 0.3;
  transform: scale(1, 0.2);

  position: absolute;
  top: calc(50% + 6px);
  left: calc(50% - 10px);
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingContainer = styled.div`
  padding: 30px;
`;
